var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classes,attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default",function(){return [(_vm.icon)?_c('fa-icon',{staticClass:"spaces-editor-toolbar-button__icon",attrs:{"icon":_vm.icon}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }